/**
 * Purchase Domain Enums
 *
 * Shared enums for purchase and payment processing.
 */

/**
 * Purchase lifecycle status
 */
export enum PurchaseStatus {
	Succeeded = "succeeded",
	Refunded = "refunded",
	PartialRefund = "partial_refund",
	Void = "void",
	Chargeback = "chargeback",
	Failed = "failed",
	Pending = "pending",
	Deleted = "deleted",
}

/**
 * Payment provider integration
 */
export enum PaymentProvider {
	Stripe = "stripe",
	Apple = "apple",
	Google = "google",
}
